import { fcwdOnly, generateData, setCDLHolder, setFcwdOnly, setIsDown } from "./data"

const PASSTHROUGH_MESSAGES = [
  "DRUG AND ALCOHOL CLEARINGHOUSE",
  "Canada is Currently Unavailable",
  "unable to connect to AAMVA",
  "Mexico eLicencia is currently unavailable",
  "Mexican Carrier/Authorization database is Currently Unavailable",
  "Foreign Conviction and Withdrawal Database (FCWD) is Currently Unavailable",
  "Transaction processing exceeded maximum time",
  "Data Processing error",
  "MULTIPLE CANADIAN SUSPENSIONS",
  "RESPONSE NOT RECEIVED",
  "TARGET JURISDICTION NOT AVAILABLE",
  "NOT ALLOWED TO DRIVE IN USA",
  "Consult the nearest Mexican Authority(SICT)",
  "Error in DBConnection builder",
  "Error inserting the logbook",
  "Error query by license number"
];

export function getExactMessages(apiMessages) {
  if (!apiMessages || !Array.isArray(apiMessages)) return "";
  
  // Convert API message to lowercase for safe matching
  const exactMatches = apiMessages.filter(apiMsg => {
    const lowerApiMsg = apiMsg.toLowerCase();
    return PASSTHROUGH_MESSAGES.some(passthrough => 
      lowerApiMsg.includes(passthrough.toLowerCase())
    );
  });
  
  // Join the matched messages with a space so they display cleanly
  return exactMatches.length > 0 ? exactMatches.join(" ") + " " : "";
}

export function MXMessages(country, fcwd, messages, cdl, timeout) {
    setIsDown("No");
    let message = '';

    if (country !== 'MX') {
      message = fcwd ? 'Data is from FCWD. If CMV = Yes, add to FCWD. If CMV = No, do not add to FCWD.' : 'Driver is not a CDL Holder. If CMV = Yes, add to FCWD. If CMV = No, do not add to FCWD';
      console.log(`Non-MX Country Message: ${message}`);
      return message;
    }

    const isTimeout = timeout ? timeout : messages.includes('Mexico eLicencia is Currently Unavailable') || messages.includes('Transaction processing exceeded maximum time [75000 ms]');
    const fcwdMatch = fcwd ? fcwd : !messages.includes('There is NO Data in the Foreign Conviction and Withdrawal Database (FCWD)');
    const sorMatch = !messages.includes('REQUESTED RECORD NOT FOUND') && 
                     !messages.includes('Mexico eLicencia is Currently Unavailable') && 
                     !messages.includes("Consult the nearest Mexican Authority(SICT)") && 
                     !messages.includes('The Data Displayed is from the Foreign Conviction and Withdrawal Database (FCWD)') && 
                     !messages.includes("NOT ALLOWED TO DRIVE IN USA") &&
                     !messages.some(msg => msg.includes('Data Processing error'));

    // Keep the logic, but don't append custom text for raw messages
    if (messages.includes('Consult the nearest Mexican Authority(SICT)')) {
      setCDLHolder(true);
    }
    if (messages.includes('NOT ALLOWED TO DRIVE IN USA')) {
      setCDLHolder(true);
    }

    if (sorMatch && !fcwdOnly) {
      setCDLHolder(true);
      message += 'Driver is a CDL Holder. Add Conviction to FCWD. ';
    } else {
      setFcwdOnly(true);
      if (isTimeout) {
          setIsDown("Yes");
          message += country === 'MX' ? 'Mexican Driver License Database is Unavailable or Down. ' : 'Foreign Country Driver License Database is Unavailable or Down. ';
      }
      if (fcwdMatch) {
          message += 'Data is from FCWD. If CMV = Yes, add to FCWD. If CMV = No, do not add to FCWD. ';
      }
    }

    // Append the raw messages exactly as sent
    const rawAppends = getExactMessages(messages);
    console.log(`Raw Appends: ${rawAppends} from messages: ${messages}`);
    if (rawAppends) {
      message += "Unified Driver Search Processing Error: " + rawAppends;
    } else if (message === '') {
      // Fallback if no specific logic or raw message was caught
      message += messages && !messages.includes('REQUESTED RECORD NOT FOUND') && !messages.includes('There is NO Data in the Foreign Conviction and Withdrawal Database (FCWD)') ? messages[0] : 'Driver is not a CDL Holder. If CMV = Yes, add to FCWD. If CMV = No, do not add to FCWD';
    }

    console.log(`MX Message: ${message} for country: ${country}, fcwdMatch: ${fcwdMatch}, sorMatch: ${sorMatch}, timeout: ${isTimeout}`);
    return message.trim();
}

// Note the added 'messages' parameter
export function CAMessages(cdl, sorMatch, fcwdMatch, partialMatch, timeout, messages = []) {
    setIsDown("No");
    console.log(`cdl: ${cdl}, sorMatch: ${sorMatch} fcwdMatch: ${fcwdMatch} partial: ${partialMatch}`);
    let message = '';
    
    if (sorMatch) {
        message += 'Data is from the Canadian province. ';
        if (cdl) {
            message += 'Driver is a CDL Holder. Add the Conviction and/or Withdrawal. ';
        } else {
            message += 'Driver is not a CDL Holder. If CMV = Yes, add to FCWD. If CMV = No, do not add to FCWD. ';
        }
    } else {
        setFcwdOnly(true);
        if (timeout) {
            setIsDown("Yes");
            message += 'Canadian Providence Database is Unavailable or Down. ';
        }
        if (partialMatch && partialMatch.length > 0) {
            message += fcwdMatch ? "Data is from FCWD. " : "";
            for (let index = 0; index < partialMatch.length; index++) {
                const key = partialMatch[index];
                if (key === 'DriverFirstName') message += " First Name Does Not Match Provincial Record;";
                else if (key === 'DriverLastName') message += " Last Name Does Not Match Provincial Record;";
                else if (key === 'LicenseState') message += " Jurisdiction Does Not Match Provincial Record;";
                else if (key === 'DriverDOB') message += " Date of Birth Does Not Match Provincial Record;";
            }
            if (message !== '') {
                message += " Conviction/Withdrawal cannot be added. ";
            }
        }
        else if (fcwdMatch) {
            message += 'Data is from FCWD. If CMV = Yes, add to FCWD. If CMV = No, do not add to FCWD. ';
        } else {
            message += 'Driver is not a CDL Holder. If CMV = Yes, add to FCWD. If CMV = No, do not add to FCWD. ';
        }
    }

    // Append the raw messages exactly as sent
    const rawAppends = getExactMessages(messages);
    if (rawAppends) {
      message += "Unified Driver Search Processing Error: " + rawAppends;
    }

    return message.trim();
}

export function withdrawalIssues(withdrawal, convictions = []) {
    
  const issues = [];
  const trim = (s) => (typeof s === 'string' ? s.trim() : '');
  const isEmpty = (s) => trim(s) === '';

  const DATE_RE_YMD = /^(\d{4})-(\d{2})-(\d{2})$/;       
  const DATE_RE_YMD_FLAT = /^(\d{4})(\d{2})(\d{2})$/;    
  const DATE_RE_MDY = /^(\d{2})\/(\d{2})\/(\d{4})$/;     

  const parseYMDnum = (val) => {

    if (!val) return null;
    const s = String(val).trim();
    let y, m, d;
    if (DATE_RE_YMD.test(s)) {
      [, y, m, d] = s.match(DATE_RE_YMD);
    } else if (DATE_RE_YMD_FLAT.test(s)) {
      [, y, m, d] = s.match(DATE_RE_YMD_FLAT);
    } else if (DATE_RE_MDY.test(s)) {
      const mm = s.slice(0, 2), dd = s.slice(3, 5), yyyy = s.slice(6);
      y = yyyy; m = mm; d = dd;
    } else {
      return null;
    }
    const yn = Number(y), mn = Number(m), dn = Number(d);

    if (mn < 1 || mn > 12 || dn < 1 || dn > 31) return null;
    return yn * 10000 + mn * 100 + dn;
  };

  const isValidDateLike = (val) => parseYMDnum(val) !== null;

  const todayYMD = (() => {
    const now = new Date();
    const y = now.getFullYear();
    const m = now.getMonth() + 1;
    const d = now.getDate();
    return y * 10000 + m * 100 + d;
  })();

  const effStr = trim(withdrawal?.DriverLicenseWithdrawalEffectiveDate);
  const eligStr = trim(withdrawal?.DRVLicWithdrawalEligibilityDate);
  const reinStr = trim(withdrawal?.DLWithdrawalReinstatementDate);
  const basis = trim(withdrawal?.DriverLicenseWithdrawalBasis);
  const extent = trim(withdrawal?.DRVLicWithdrawalExtentIdDlc);
  const acd = trim(withdrawal?.DRVLicAcdWithdrawalReasonCode);
  
  // Check for missing underlying conviction for ACD codes
  const ACD_CODES_REQUIRING_CONVICTION = new Set([
    'A41', 'B61', 'B63', 'B64', 'B65', 'D02', 'D30', 'D35', 'D36', 
    'D37', 'D38', 'D39', 'W00', 'W09', 'W13', 'W14', 'W15', 'W20', 
    'W27', 'W28', 'W70', 'W72', 'W80', 'W81', 'W82'
  ]);

  if (!ACD_CODES_REQUIRING_CONVICTION.has(acd) && convictions.length === 0) {
    issues.push(`${acd} CONVICTION LINK MISSING FOR WITHDRAWAL`);
  }

  const NO_LINK_ALLOWED = new Set(['W00','W27','W28','W72','W80','W81','W82']);
  if (NO_LINK_ALLOWED.has(acd) && convictions && convictions.length > 0) {
    issues.push('The ACD Code does not allow a Linked Conviction.');
  }

  // Check for conviction match
  if (convictions.length === 1) {
    const linkedConvictionAcd = convictions[0]?.ConvictionOffenseAcdCode?.Code;
    if (linkedConvictionAcd && linkedConvictionAcd !== acd && !acd.startsWith('W')) {
      issues.push(`${linkedConvictionAcd} linked conviction ACD Code does not match withdrawal ACD Code ${acd}.`);
    }
  }

  // Check for W45 withdrawal
  if (acd === 'W45' && convictions.length > 0) {
    const underlyingConvictionAcd = convictions[0]?.ConvictionOffenseAcdCode?.Code;
    if (!['B20', 'B21', 'B22', 'B23', 'B24', 'B25', 'B26'].includes(underlyingConvictionAcd)) {
      issues.push('W45 withdrawal requires a B20-B26 underlying conviction.');
    }
  }

  // Check for W30, W60, W50, W51 requiring two convictions
  if (['W30', 'W60', 'W50', 'W51'].includes(acd) && convictions.length < 2) {
    issues.push(`${2 - convictions.length} CONVICTION LINK(S) MISSING FOR WITHDRAWAL`);
  }

  // Check for W31, W61, W52 requiring three convictions
  if (['W31', 'W61', 'W52'].includes(acd) && convictions.length < 3) {
    issues.push(`${3 - convictions.length} CONVICTION LINK(S) MISSING FOR WITHDRAWAL`);
  }

  const locator = trim(withdrawal?.DLWithdrawalJurisdictionReportId);
  const stateNative = trim(withdrawal?.DRVLicWithdrawalReasonReference);
  const comments = trim(withdrawal?.WithdrawalStatusNotes);

  const eligIsTextFlag = eligStr.toUpperCase() === 'INDEF' || eligStr.toUpperCase() === 'PERM';
  const eligIsDate = !eligIsTextFlag && !isEmpty(eligStr);

  const effNum = parseYMDnum(effStr);
  const eligNum = eligIsDate ? parseYMDnum(eligStr) : null;
  const reinNum = isEmpty(reinStr) ? null : parseYMDnum(reinStr);

  // if (isEmpty(effStr)) issues.push('Please enter an Effective Date');                   
  // if (!eligIsTextFlag && isEmpty(eligStr)) issues.push('Please enter an Eligible Date');
  if (isEmpty(locator)) issues.push('Please enter a Withdrawal Locator Number.');       
  if (isEmpty(stateNative)) issues.push('Please enter a State Native Code');            
  if (isEmpty(comments)) issues.push('Please provide comments for the audit file.');    
  if (!isEmpty(effStr) && !isValidDateLike(effStr)) issues.push('Invalid Effective Date');    
  if (eligIsDate && !isValidDateLike(eligStr)) issues.push('Invalid Eligible Date');         
  if (!isEmpty(reinStr) && !isValidDateLike(reinStr)) issues.push('Invalid Reinstatement Date');

  const datesOK = (!isEmpty(effStr) ? effNum !== null : false) &&
                  (!eligIsDate || eligNum !== null) &&
                  (isEmpty(reinStr) || reinNum !== null);

  if (datesOK && convictions && convictions.length > 0) {
    const USE_CIT_FOR = new Set(['A04','A08','A10','A11','A12','A20','A21','A22','A23']);
    convictions.forEach(c => {
      const cAcd = c?.ConvictionOffenseAcdCode?.Code ? String(c.ConvictionOffenseAcdCode.Code).toUpperCase() : '';
      const convDateNum = parseYMDnum(c?.ConvictionDate);
      const citDateNum  = parseYMDnum(c?.CitationDate);
      if (USE_CIT_FOR.has(cAcd)) {
        if (citDateNum != null && effNum < citDateNum) {
          issues.push(`EFFEC DATE MUST BE EQUAL TO OR LATER THAN CIT DATE, ACD CODE: ${cAcd}`);
        }
      } else {
        if (convDateNum != null && effNum < convDateNum) {
          issues.push(`EFFEC DATE MUST BE EQUAL TO OR LATER THAN CONV DATE, ACD CODE: ${cAcd || '##'}`);
        }
      }
    });
  }

  if (datesOK && eligIsDate && eligNum < effNum) {
    issues.push('ELIG DATE MUST BE EQUAL TO OR LATER THAN EFFEC DATE');
  }

  if (datesOK && reinNum != null && reinNum > todayYMD) {
    issues.push('REINSTATE DATE MUST NOT BE LATER THAN MESSAGE DATE');
  }

  if (datesOK && eligIsDate && effNum > eligNum) {

    issues.push('ELIG DATE MUST BE EQUAL TO OR LATER THAN EFFEC DATE');
  }

  if (datesOK && eligIsDate && reinNum != null && eligNum > reinNum) {
    issues.push('ELIG DATE MUST BE EQUAL TO OR EARLIER THAN REINST DATE');
  }

  const ACD_CUTOFFS = {

    'M85': {cutoff: 20101027, msg: 'M85 INVALID EFFECTIVE DATE FOR WDRAW ACD'},
    'B57': {cutoff: 20110801, msg: 'B57 INVALID EFFECTIVE DATE FOR WDRAW ACD'},
    'M86': {cutoff: 20110801, msg: 'M86 INVALID EFFECTIVE DATE FOR WDRAW ACD'},
    'D30': {cutoff: 20110708, msg: 'D30 INVALID EFFECTIVE DATE FOR WDRAW ACD'},
    'D31': {cutoff: 20110708, msg: 'D31 INVALID EFFECTIVE DATE FOR WDRAW ACD'},
    'W27': {cutoff: 20110708, msg: 'W27 INVALID EFFECTIVE DATE FOR WDRAW ACD'},
    'W28': {cutoff: 20110708, msg: 'W28 INVALID EFFECTIVE DATE FOR WDRAW ACD'},
    'W82': {cutoff: 20130901, msg: 'W82 INVALID EFFECTIVE DATE FOR WDRAW ACD'},
    'A91': {cutoff: 20101108, msg: 'A91 INVALID WITHDRAWAL ACD REASON CODE'},
    'B78': {cutoff: 20091109, msg: 'B78 INVALID EFFECTIVE DATE FOR WDRAW ACD'},
    'S14': {cutoff: 20091109, msg: 'S14 INVALID EFFECTIVE DATE FOR WDRAW ACD'},
    'U27': {cutoff: 20091109, msg: 'U27 INVALID EFFECTIVE DATE FOR WDRAW ACD'},
    'U28': {cutoff: 20091109, msg: 'U28 INVALID EFFECTIVE DATE FOR WDRAW ACD'},
    'W80': {cutoff: 20091109, msg: 'W80 INVALID EFFECTIVE DATE FOR WDRAW ACD'},
    'W81': {cutoff: 20091109, msg: 'W81 INVALID EFFECTIVE DATE FOR WDRAW ACD'},
    'W45': {cutoff: 20081110, msg: 'W45 INVALID WITHDRAWAL ACD REASON CODE'},
    'W72': {cutoff: 20081110, msg: 'W72 INVALID WITHDRAWAL ACD REASON CODE'},
  };
  if (datesOK && acd && ACD_CUTOFFS[acd]) {
    const { cutoff, msg } = ACD_CUTOFFS[acd];
    if (effNum < cutoff) issues.push(msg);
  }

  const BASIS_NEQ_9 = new Set(['A04','A08','A10','A11']);
  const BASIS_EQ_9  = new Set(['A90','A91','A94','A95','A98']);
  if (acd) {
    if (BASIS_NEQ_9.has(acd) && basis === '9') {
      issues.push(`${acd} INVALID BASIS FOR WDRAW ACD`);
    }
    if (BASIS_EQ_9.has(acd) && basis !== '9') {
      issues.push(`${acd} INVALID BASIS FOR WDRAW ACD`);
    }

    const NOV_08_2010 = 20101108;
    if (datesOK && effNum >= NOV_08_2010 && BASIS_NEQ_9.has(acd) && basis === '9') {
      issues.push(`${acd} INVALID BASIS FOR WDRAW ACD`);
    }
  }

  if (acd === 'W27' || acd === 'W28') {
    if (eligStr.toUpperCase() !== 'INDEF') {
      issues.push(`${acd} INVALID ELIGIBILITY DATE FOR WDRAW ACD`);
    }
  }

  const EXTENT_1_OR_3 = new Set(['W40','W41','W45']);
  if (EXTENT_1_OR_3.has(acd) && !(extent === '1' || extent === '3')) {
    issues.push(`${acd} INVALID WITHDRAWAL EXTENT FOR ACD`);
  }

  const OCT_01_2005 = 20051001;
  const EXTENT_WITH_DATE = new Set(['U09','U10','W09']);
  if (datesOK && effNum >= OCT_01_2005 && EXTENT_WITH_DATE.has(acd) && !(extent === '1' || extent === '3')) {
    issues.push(`${acd} INVALID WITHDRAWAL EXTENT FOR ACD`);
  }

  const seen = new Set();
  return issues.filter(m => (seen.has(m) ? false : (seen.add(m), true)));
}
